<template>
    <div class="pedido-progress">
        <div class="horizontal">
            <div class="pedido-progress-desc-row" ref="progressDescRow">
                <div class="pedido-progress-desc" :style="{height: descHeights[0]}">
                    <div class="pedido-progress-desc-pos" :style="{width: widthDescCalc}">
                        Compra
                    </div>
                </div>
                <div class="pedido-progress-desc" :style="{height: descHeights[1]}">
                    <div class="pedido-progress-desc-pos" :style="{width: widthDescCalc}">
                        Última oportunidad de modificación del a medida
                    </div>
                </div>
                <div class="pedido-progress-desc" :style="{height: descHeights[2]}">
                    <div class="pedido-progress-desc-pos" :style="{width: widthDescCalc}">
                        Última oportunidad para añadir disponible y completar el pago
                    </div>
                </div>
                <div class="pedido-progress-desc" :style="{height: descHeights[3]}">
                    <div class="pedido-progress-desc-pos" :style="{width: widthDescCalc}">
                        Entrega
                    </div>
                </div>
            </div>
            <div class="pedido-progress-bar-row">
                <div class="pedido-progress-icon-wrapper active">
                    <img src="/img/iconos/pedido-progress-compra.svg" alt="Compra" class="pedido-progress-icon">
                </div>
                <div class="pedido-progress-bar" ref="firstStepBar">
                    <div class="pedido-progress-bar-active" :style="{width: firstBarWidth}">
                    </div>
                    <div class="pedido-progress-bar-head" :style="extraStyleFirstBarHead"></div>
                </div>
                <div class="pedido-progress-icon-wrapper" :class="{'active': isLastModActive}">
                    <img src="/img/iconos/pedido-progress-last-mod.svg" alt="Última modificación" class="pedido-progress-icon">
                </div>
                <div class="pedido-progress-bar">
                    <div class="pedido-progress-bar-active" :style="{width: secondBarWidth}">
                    </div>
                    <div class="pedido-progress-bar-head" :style="extraStyleSecondBarHead"></div>
                </div>
                <div class="pedido-progress-icon-wrapper" :class="{'active': isFechaUltimoPago}">
                    <img src="/img/iconos/pedido-progress-pay.svg" alt="Última oportunidad de pago" class="pedido-progress-icon">
                </div>
                <div class="pedido-progress-bar">
                    <div class="pedido-progress-bar-active" :style="{width: thirdBarWidth}">
                    </div>
                    <div class="pedido-progress-bar-head" :style="extraStyleThirdBarHead"></div>
                </div>
                <div class="pedido-progress-icon-wrapper" :class="{'active': isFechaEnvioActive}">
                    <img src="/img/iconos/pedido-progress-envio.svg" alt="Envío" class="pedido-progress-icon">
                </div>
            </div>
            <div class="pedido-progress-date-row" ref="progressDateRow">
                <div class="pedido-progress-date" :style="{height: dateHeights[0]}">
                    <div class="pedido-progress-date-pos" :style="{width: widthDescCalc}">
                        {{ fechaFormattedStep }}
                    </div>
                </div>
                <div class="pedido-progress-date" :style="{height: dateHeights[1]}">
                    <div class="pedido-progress-date-pos" :style="{width: widthDescCalc}">
                        {{ fechaLastModFormatted }}
                    </div>
                </div>
                <div class="pedido-progress-date" :style="{height: dateHeights[2]}">
                    <div class="pedido-progress-date-pos" :style="{width: widthDescCalc}">
                        {{ fechaUltimoPagoFormatted }}
                    </div>
                </div>
                <div class="pedido-progress-date" :style="{height: dateHeights[3]}">
                    <div class="pedido-progress-date-pos" :style="{width: widthDescCalc}">
                        {{ fechaEnvioFormatted }}
                    </div>
                </div>
            </div>
        </div>
        <div class="vertical">
            <div class="pedido-progress-bar-row">
                <div class="pedido-progress-icon-wrapper active">
                    <img src="/img/iconos/pedido-progress-compra.svg" alt="Compra" class="pedido-progress-icon">
                </div>
                <div class="pedido-progress-bar" ref="firstVerticalStepBar">
                    <div class="pedido-progress-bar-active" :style="{height: firstBarWidth}">
                    </div>
                    <div class="pedido-progress-bar-head" :style="extraStyleFirstBarHeadVertical"></div>
                </div>
                <div class="pedido-progress-icon-wrapper" :class="{'active': isLastModActive}">
                    <img src="/img/iconos/pedido-progress-last-mod.svg" alt="Última modificación" class="pedido-progress-icon">
                </div>
                <div class="pedido-progress-bar">
                    <div class="pedido-progress-bar-active" :style="{height: secondBarWidth}">
                    </div>
                    <div class="pedido-progress-bar-head" :style="extraStyleSecondBarHeadVertical"></div>
                </div>
                <div class="pedido-progress-icon-wrapper" :class="{'active': isFechaUltimoPago}">
                    <img src="/img/iconos/pedido-progress-pay.svg" alt="Última oportunidad de pago" class="pedido-progress-icon">
                </div>
                <div class="pedido-progress-bar">
                    <div class="pedido-progress-bar-active" :style="{height: thirdBarWidth}">
                    </div>
                    <div class="pedido-progress-bar-head" :style="extraStyleThirdBarHeadVertical"></div>
                </div>
                <div class="pedido-progress-icon-wrapper" :class="{'active': isFechaEnvioActive}">
                    <img src="/img/iconos/pedido-progress-envio.svg" alt="Envío" class="pedido-progress-icon">
                </div>
            </div>
            <div class="pedido-progress-desc-col">
                <div class="pedido-progress-desc-date-vertical">
                    <div class="pedido-progress-desc-vertical-pos" :style="{height: heightDescCalcVertical, transform: verticalCenterTransform}">
                        <div class="pedido-progress-desc-vertical">
                            Compra
                        </div>
                        <div class="pedido-progress-date-vertical">
                            {{ fechaFormattedStep }}
                        </div>
                    </div>
                </div>
                <div class="pedido-progress-desc-date-vertical">
                    <div class="pedido-progress-desc-vertical-pos" :style="{height: heightDescCalcVertical, transform: verticalCenterTransform}">
                        <div class="pedido-progress-desc-vertical">
                            Última oportunidad de modificación del a medida
                        </div>
                        <div class="pedido-progress-date-vertical">
                            {{ fechaLastModFormatted }}
                        </div>
                    </div>
                </div>
                <div class="pedido-progress-desc-date-vertical">
                    <div class="pedido-progress-desc-vertical-pos" :style="{height: heightDescCalcVertical, transform: verticalCenterTransform}">
                        <div class="pedido-progress-desc-vertical">
                            Última oportunidad para añadir disponible y completar el pago
                        </div>
                        <div class="pedido-progress-date-vertical">
                            {{ fechaUltimoPagoFormatted }}
                        </div>
                    </div>
                </div>
                <div class="pedido-progress-desc-date-vertical">
                    <div class="pedido-progress-desc-vertical-pos" :style="{height: heightDescCalcVertical, transform: verticalCenterTransform}">
                        <div class="pedido-progress-desc-vertical">
                            Envío
                        </div>
                        <div class="pedido-progress-date-vertical">
                            {{ fechaEnvioFormatted }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PedidoProgress",
    props: {
        compraDate: {},
        bloqueoDate: {},
        ultimoPagoDate: {},
        envioDate: {}
    },
    data() {
        return {
            widthDescCalc: "100%",
            heightDescCalcVertical: "100%",
            verticalCenterTransform: "translateY(0%)",
            descHeights: ['1.5em', '1.5em', '1.5em', '1.5em'],
            dateHeights: ['1.5em', '1.5em', '1.5em', '1.5em'],
            widthHeadFixedPercent: 18,
            heightHeadFixedPercentVertical: 25,
            today: moment().startOf('day'),
            formatDateDisplay: 'D [de] MMMM',
        }
    },
    computed: {
        stepDates() {
            return [
                this.compraDate, this.bloqueoDate, this.ultimoPagoDate, this.envioDate
            ]
        },
        fechaFormattedStep() {
            return this.stepDateFormatted(0);
        },
        fechaLastModFormatted() {
            return this.stepDateFormatted(1);
        },
        firstBarPercent() {
            return this.barPercent(0);
        },
        secondBarPercent() {
            return this.barPercent(1);
        },
        thirdBarPercent() {
            return this.barPercent(2);
        },
        firstBarWidth() {
            let percent = this.firstBarPercent;
            return percent + "%";
        },
        secondBarWidth() {
            let percent = this.secondBarPercent;
            return percent + "%";
        },
        thirdBarWidth() {
            let percent = this.thirdBarPercent;
            return percent + "%";
        },
        extraStyleFirstBarHead() {
            return this.extraStyleBarHead(this.firstBarPercent);
        },
        extraStyleSecondBarHead() {
            return this.extraStyleBarHead(this.secondBarPercent);
        },
        extraStyleThirdBarHead() {
            return this.extraStyleBarHead(this.thirdBarPercent);
        },
        extraStyleFirstBarHeadVertical() {
            return this.extraStyleBarHead(this.firstBarPercent, 'vertical');
        },
        extraStyleSecondBarHeadVertical() {
            return this.extraStyleBarHead(this.secondBarPercent, 'vertical');
        },
        extraStyleThirdBarHeadVertical() {
            return this.extraStyleBarHead(this.thirdBarPercent, 'vertical');
        },
        isLastModActive() {
            return this.isStepActive(1);
        },
        fechaUltimoPagoFormatted() {
            return this.stepDateFormatted(2);
        },
        isFechaUltimoPago() {
            return this.isStepActive(2);
        },
        fechaEnvioFormatted() {
            return this.stepDateFormatted(3);
        },
        isFechaEnvioActive() {
            return this.isStepActive(3);
        }
    },
    methods: {
        recalculeWidthDesc() {
            let firstBarRef = this.$refs.firstStepBar;
            if (firstBarRef !== undefined) {
                this.widthDescCalc = "calc(100% + " + firstBarRef.clientWidth + "px)";
            }
            let firstVerticalBarRef = this.$refs.firstVerticalStepBar;
            if (firstVerticalBarRef) {
                let height = firstVerticalBarRef.clientHeight;
                this.heightDescCalcVertical = "calc(100% + " + height + "px)";
                this.verticalCenterTransform = "translateY(-" + height/2 + "px)";
            }
            this.$nextTick(() => {
                let progressDescRowRef = this.$refs.progressDescRow;
                if (progressDescRowRef !== undefined) {
                    let progressDescs = progressDescRowRef.querySelectorAll('.pedido-progress-desc');
                    if (progressDescs) {
                        let newDescHeights = ['1.5em', '1.5em', '1.5em', '1.5em'];
                        progressDescs.forEach((pd, index) => {
                            let ppdpChild = pd.querySelector('.pedido-progress-desc-pos');
                            if (ppdpChild) {
                                newDescHeights[index] = ppdpChild.clientHeight + 'px';
                            }
                        })
                        this.descHeights = newDescHeights;
                    }
                }
                let dateRowRef = this.$refs.progressDateRow;
                if (dateRowRef !== undefined) {
                    let progressDates = dateRowRef.querySelectorAll('.pedido-progress-date');
                    if (progressDates) {
                        let newDateHeights = ['1.5em', '1.5em', '1.5em', '1.5em'];
                        progressDates.forEach((pd, index) => {
                            let ppdpChild = pd.querySelector('.pedido-progress-date-pos');
                            if (ppdpChild) {
                                newDateHeights[index] = ppdpChild.clientHeight + 'px';
                            }
                        })
                        this.dateHeights = newDateHeights;
                    }
                }
            });
        },
        barPercent(step) {
            let percent = 0;
            if (this.isStepActive(step+1)) {
                percent = 100;
            } else if (this.isStepActive(step)) {
                let today = this.today;
                let nextStepDate = moment(this.stepDates[step+1]).startOf('day');
                let stepDate = moment(this.stepDates[step]).startOf('day');
                let totalDays = nextStepDate.diff(stepDate, 'days');
                let diffDaysToday = today.diff(stepDate, 'days');
                if (totalDays > 1) {
                    percent = diffDaysToday * 100 / totalDays;
                } else {
                    percent = 50;
                }
            }
            return percent;
        },
        isStepActive(step) {
            let today = this.today;
            let stepDate = moment(this.stepDates[step]).startOf('day');
            return stepDate.diff(today, 'days') <= 0;
        },
        extraStyleBarHead(percent, style='horizontal') {
            let extraStyles = {};
            let barPercent = percent;
            if (barPercent <= 0 || barPercent === 100) {
                extraStyles.display = 'none';
            } else {
                if (style === 'vertical') {
                    let heightFixed = this.heightHeadFixedPercentVertical;
                    extraStyles.height = heightFixed + '%';

                    if (barPercent <= (heightFixed / 2)) {
                        extraStyles.top = 0;
                    } else if (barPercent >= (100 - heightFixed / 2)) {
                        extraStyles.bottom = 0;
                    } else {
                        extraStyles.top = barPercent - (heightFixed / 2) + '%';
                    }
                } else {
                    let widthFixed = this.widthHeadFixedPercent;
                    extraStyles.width = widthFixed + '%';

                    if (barPercent <= (widthFixed / 2)) {
                        extraStyles.left = 0;
                    } else if (barPercent >= (100 - widthFixed / 2)) {
                        extraStyles.right = 0;
                    } else {
                        extraStyles.left = barPercent - (widthFixed / 2) + '%';
                    }
                }
            }
            return extraStyles;
        },
        stepDateFormatted(step) {
            return moment(this.stepDates[step]).format(this.formatDateDisplay);
        }
    },
    mounted() {
        this.recalculeWidthDesc();
        window.addEventListener('resize', this.recalculeWidthDesc);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.recalculeWidthDesc);
    }
}
</script>

<style scoped>

    .pedido-progress {
        flex: 1 1 100%;
        margin-top: 0.75rem;
    }

    .pedido-progress .horizontal {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        width: 100%;
    }

    .pedido-progress .vertical {
        display: none;
    }

    .pedido-progress-desc-row {
        display: flex;
        justify-content: space-between;
        color: #007b82;
        font-weight: bold;
        padding-left: 2rem;
        padding-right: 2rem;
        align-items: flex-end;
    }

    .pedido-progress-desc-col {
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        padding-left: 0.75rem;
        flex-direction: column;
        align-items: flex-start;
        flex: 1 1 auto;
    }

    .pedido-progress-desc-date-vertical {
        width: 100%;
        flex: 0 0 auto;
        height: 2.4rem;
        position: relative;
    }

    .pedido-progress-desc-vertical-pos {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .pedido-progress-desc-vertical {
        color: #007b82;
        line-height: 1.2em;
    }

    .pedido-progress-date-vertical {
        line-height: 1.2em;
        margin-top: 0.2rem;
    }

    .pedido-progress-desc {
        flex: 0 0 2.4rem;
        text-align: center;
        height: 1.5em;
        position: relative;
    }

    .pedido-progress-desc-pos {
        position: absolute;
        margin-left: 50%;
        transform: translateX(-50%);
    }

    .pedido-progress-bar-row {
        display: flex;
        justify-content: space-between;
        padding-left: 2rem;
        padding-right: 2rem;
        align-items: center;
    }

    .vertical .pedido-progress-bar-row {
        flex-direction: column;
        padding-left: 0;
        padding-right: 0;
    }

    .pedido-progress-bar {
        width: 100%;
        height: 0.5rem;
        background-color: #989898;
        position: relative;
    }

    .vertical .pedido-progress-bar {
        width: 0.5rem;
        height: 2.4rem;
    }

    .pedido-progress-bar-active {
        position: absolute;
        background-color: #007b82;
        height: 100%;
    }

    .vertical .pedido-progress-bar-active {
        width: 100%;
    }

    .pedido-progress-bar-head {
        height: 200%;
        background-color: #007b82;
        position: absolute;
        top: -50%;
        border-radius: 0.3rem;
    }

    .vertical .pedido-progress-bar-head {
        width: 200%;
        top: auto;
        left: -50%;
        border-radius: 0.2rem;
    }

    .pedido-progress-date-row {
        display: flex;
        justify-content: space-between;
        padding-left: 2rem;
        padding-right: 2rem;
        align-items: center;
    }

    .pedido-progress-date {
        flex: 0 0 2.4rem;
        text-align: center;
        height: 1.5em;
        position: relative;
    }

    .pedido-progress-date-pos {
        position: absolute;
        margin-left: 50%;
        transform: translateX(-50%);
    }

    .pedido-progress-icon {
        height: 2rem;
        width: 2rem;
    }

    .pedido-progress-icon-wrapper {
        padding: 0.05rem;
        border: 0.3rem solid transparent;
        border-radius: 50%;
    }

    .pedido-progress-icon-wrapper.active {
        border-color: #007b82;
    }

    @media screen and (max-width: 991px) {
        .pedido-progress .horizontal {
            display: none;
        }

        .pedido-progress .vertical {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            display: flex;
            justify-content: space-between;
            width: 100%;
            align-items: stretch;
        }
    }
</style>
